export var DynamicCopyType;
(function (DynamicCopyType) {
    DynamicCopyType["EMBED"] = "embed";
    DynamicCopyType["FORM"] = "form";
    DynamicCopyType["FORM_OPTION"] = "formOption";
    DynamicCopyType["LINK"] = "link";
    /**
     * Not supported by DynamicCopy.vue
     * Allows a list of options to be displayed as a select
     */
    DynamicCopyType["SELECT"] = "select";
    DynamicCopyType["TITLE_SUBTITLE"] = "titleSubtitle";
})(DynamicCopyType || (DynamicCopyType = {}));
//# sourceMappingURL=dynamicCopy.js.map